import * as React from 'react';

import AxaLogo from 'assets/Insures/axa.jpg';
import BolivarLogo from 'assets/Insures/bolivar.png';
import EquidadLogo from 'assets/Insures/equidad.png';
import EstadoLogo from 'assets/Insures/estado.png';
import HdiLogo from 'assets/Insures/hdi.png';
import SbsLogo from 'assets/Insures/sbs.png';
import SuraLogo from 'assets/Insures/sura.png';
import LibertyLogo from 'assets/Insures/liberty.png';
import ZurichLogo from 'assets/Insures/zurich.png';
import MapfreLogo from 'assets/Insures/mapfre.png';
import PrevisoraLogo from 'assets/Insures/previsora.png';
import SolidariaLogo from 'assets/Insures/solidariaLogo.png';

enum Insurances {
  AXA = 'AXA',
  BOLIVAR = 'BOLIVAR',
  EQUIDAD = 'EQUIDAD',
  ESTADO = 'ESTADO',
  HDI = 'HDI',
  MAPFRE = 'MAPFRE',
  SBS = 'SBS',
  SURA = 'SURA',
  LIBERTY = 'LIBERTY',
  ZURICH = 'ZURICH',
  HDI_B = 'HDI_B',
  PREVISORA = 'PREVISORA',
  SOLIDARIA = 'SOLIDARIA',
}

const InsuranceLogoReSize: React.FC<IInsuranceLogoPropsReSize> = ({ insurance, width, heigth }) => {
  if (insurance === Insurances.AXA) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={AxaLogo}
        alt="axa logo"
      />
    );
  }
  if (insurance === Insurances.BOLIVAR) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={BolivarLogo}
        alt="bolivar logo"
      />
    );
  }
  if (insurance === Insurances.EQUIDAD) {
    return (
      <img
        width={40}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={EquidadLogo}
        alt="equidad logo"
      />
    );
  }
  if (insurance === Insurances.ZURICH) {
    return (
      <img
        width={100}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={ZurichLogo}
        alt="zurich logo"
      />
    );
  }
  if (insurance === Insurances.ESTADO) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={EstadoLogo}
        alt="estado logo"
      />
    );
  }
  if (insurance === Insurances.HDI) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={HdiLogo}
        alt="hdi logo"
      />
    );
  }
  if (insurance === Insurances.MAPFRE) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={MapfreLogo}
        alt="mapfre logo"
      />
    );
  }
  if (insurance === Insurances.SBS) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={SbsLogo}
        alt="sbs logo"
      />
    );
  }
  if (insurance === Insurances.SURA) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={SuraLogo}
        alt="sura logo"
      />
    );
  }
  if (insurance === Insurances.LIBERTY) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={LibertyLogo}
        alt="liberty logo"
      />
    );
  }
  if (insurance === Insurances.HDI_B) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={HdiLogo}
        alt="hdi logo"
      />
    );
  }
  if (insurance === Insurances.PREVISORA) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={PrevisoraLogo}
        alt="previsora logo"
      />
    );
  }
  if (insurance === Insurances.SOLIDARIA) {
    return (
      <img
        width={width}
        height={heigth}
        style={{ objectFit: 'contain' }}
        src={SolidariaLogo}
        alt="solidaria logo"
      />
    );
  }
  return null;
};

export default InsuranceLogoReSize;
